// Styles
import '../scss/style.scss';
import 'owl.carousel/dist/owl.carousel.min';

// Vendors
import 'lightbox2';
import 'accordionjs';
import 'owl.carousel';




// TODO - delete this
import * as global from './global';
global.init();

// Partials - TODO check this
import '../../partials';
